import { Injectable, signal } from '@angular/core';

export interface OverlayPosition {
  top: number;
  left: number;
  width: number;
  height: number;
}

@Injectable({ providedIn: 'root' })
export class CodeServerOverlayService {
  minimized = signal(false);
  maximized = signal(false);
  position = signal<OverlayPosition | null>(null);

  minimize() {
    this.minimized.set(true);
  }

  restore() {
    this.minimized.set(false);
  }

  maximize() {
    this.maximized.set(true);
  }

  unmaximize() {
    this.maximized.set(false);
  }

  updatePosition(pos: OverlayPosition) {
    this.position.set(pos);
  }

  reset() {
    this.minimized.set(false);
    this.maximized.set(false);
    this.position.set(null);
  }
}
